import { PageListDataSource } from './BaseDataSources';
import { ISearchMapping, IMappingFilter } from '../Interfaces';

export class MappingSource extends PageListDataSource<ISearchMapping> {
  public constructor(filter: IMappingFilter = { importProcessIdList: [1] }, pageSize: number = 50) {
    super('/componentapi/dataimport/mappings', filter, pageSize);
  }
}